module.exports = __webpack_public_path__ + "img/404.0f8c7911.png";